import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./program.css";
import { getCurrentPrograms } from "./programsData";

const ConferenceSchedule = () => {
  const [currentPrograms, setCurrentPrograms] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const programs = getCurrentPrograms();
    console.log("Fetched current programs:", programs);
    setCurrentPrograms(programs);
  }, []);

  const handleImageClick = () => {
    navigate("/events");
  };

  const handlePastEventsClick = () => {
    navigate("/past-programs");
  };

  return (
    <div className="conference-schedule">
      <div className="conference-schedule-container">
        <div className="conference-highlight">
          <div className="flyers-container">
            <h3>Current Programs</h3>
            {currentPrograms.length === 0 ? (
              <div className="no-events">
                <p>No upcoming events at the moment.</p>
                <button onClick={handlePastEventsClick} className="view-past-events">View Past Events</button>
              </div>
            ) : (
              <div className="flyers-grid">
                {currentPrograms.map((program) => (
                  <div key={program.id} className="flyer-item">
                    <img
                      src={program.image}
                      alt={program.name}
                      className="flyer-image"
                      onClick={handleImageClick}
                      onError={(e) => {
                        console.log(`Failed to load image: ${program.image}`);
                        e.target.style.display = "none";
                      }}
                    />
                    <div className="flyer-overlay">
                      <p className="click-message">Click to register</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConferenceSchedule;
